import { QueryFactory } from "../../../../Common";
export const QGetTopLeaguesBySportId = QueryFactory("GetTopLeaguesBySportId");
//# sourceMappingURL=QGetTopLeaguesBySportId.js.map